import type {ReactElement} from 'react';
import {useEffect, useRef} from 'react';
import {Icon} from '@Components/icon-v2';
import {Text, TextSize} from '@Components/text';
import {IconSize} from '@Components/icon-v2/icon.types';
import styles from './custom-list-item.module.scss';

export interface CustomListItemProps {
  id: string;
  svgOrIcon?: ReactElement;
  className?: string;
  isSelected?: boolean;
  text?: string;
  onClick(id: string): void;
  doScrollIntoView?: boolean;
  svgClassName?: string;
  showSelectedCheckIcon?: boolean;
}

export function CustomListItem({className = '', isSelected = false, doScrollIntoView = false, showSelectedCheckIcon = true, ...props}: CustomListItemProps): ReactElement {
  const ref = useRef<HTMLLIElement>(null);

  useEffect(() => {
    if (ref.current && doScrollIntoView && isSelected) {
      ref.current.scrollIntoView({behavior: 'instant', block: 'center'});
    }
  }, [isSelected, doScrollIntoView]);

  return (
    <li
      ref={ref}
      id={props.id}
      onClick={(): void => {
        props.onClick(props.id);
      }}
      className={`${styles.container} ${className} ${isSelected ? styles.selected : ''} hover-transition-all radius-4 flex-row-justify-between flex-items-center spacing-p-3`}
    >
      <div className="flex-h-row flex-items-center">
        {props.svgOrIcon ? <div className={`${styles.svgContainer} ${props.svgClassName} flex-center`}>{props.svgOrIcon}</div> : null}
        {props.text ? <Text val={props.text} bold={isSelected} size={TextSize.XSMALL} className={isSelected ? 'content-primary' : ''} /> : null}
      </div>
      {isSelected && showSelectedCheckIcon ? <Icon icon="icon-check" size={IconSize.SIZE_ICON_20} className="content-primary" /> : null}
    </li>
  );
}
